import React from 'react';

const teamMembers = [
  {
    name: 'Ben Duckett',
    role: 'Founder',
    linkedin: 'https://www.linkedin.com/in/ben-duckett-407a1b98/',
    bio: [
      "Ben, the founder of PH Therapy, has over ten years of experience as a Clinical Exercise Physiologist. He has worked with a variety of clinical conditions, including musculoskeletal (MSK), heart failure, CABG, renal transplant, and individuals at various stages along the cancer continuum. PH Therapy delivers programmes across London, Wimbledon, Fulham, Kensington, Chiswick, Surrey, and Sussex.",
      "Ben has a passion and drive for helping people using exercise and behaviour change to make long-lasting improvements in their health. The cornerstone of PH Therapy and Ben's ethos is a bespoke programme with a high attention to detail and keeping it 'fun' to keep you consistent.",
      "Ben is also a guest lecturer at the University of Central Lancashire on the role of exercise and physical activity in cancer care. Alongside that he is a member of the Practitioner Working Group for CEP UK to help bring change in the industry.",
      "Outside of running PH Therapy, Ben enjoys dabbling with CrossFit, Hyrox, running, and getting back into the mountains in Ireland when he can."
    ],
    image: 'TeamMember1.png',
    alt: 'Ben Duckett, Founder of PH Therapy and Clinical Exercise Physiologist'
  },
  {
    name: 'Reilly Smith',
    role: 'Clinical Exercise Physiologist',
    linkedin: 'https://www.linkedin.com/in/ACoAABpUsi4BQNO4nn2KOrraa1LrduVvBmz979o/',
    bio: [
      "Reilly is a qualified Exercise Physiologist and Exercise Scientist from Australia, with a strong interest in musculoskeletal conditions and rehabilitation. He has experience working across a broad spectrum of clients — from elite athletes to individuals recovering from serious health conditions, including cardiac and cancer-related diagnoses.",
      "Reilly is passionate about the role of exercise as a cornerstone of effective rehabilitation. He takes a person-centred approach, meeting individuals where they are to help build consistency and improve long-term health outcomes.",
      "Outside of work, he enjoys travelling across Europe and exploring different varieties of red wine."
    ],
    image: 'TeamMember2.png',
    alt: 'Reilly Smith, Clinical Exercise Physiologist at PH Therapy'
  }
];

const Team: React.FC = () => {
  return (
    <section id="team" className="team">
      <div className="container">
        <h2>Meet Our Team</h2>
        <div className="team-grid">
          {teamMembers.map((member) => (
            <div key={member.name} className="team-member">
              <img
                src={`${process.env.PUBLIC_URL}/${member.image}`}
                alt={member.alt}
              />
              <h3>{member.name}</h3>
              <p>{member.role}</p>
              {Array.isArray(member.bio)
                ? member.bio.map((paragraph, i) => <p key={i}>{paragraph}</p>)
                : <p>{member.bio}</p>}
              {member.linkedin && (
                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="team-linkedin"
                  aria-label={`Connect with ${member.name} on LinkedIn`}
                >
                  <i className="fab fa-linkedin" aria-hidden="true" />
                  Connect on LinkedIn
                </a>
              )}
            </div>
          ))}
        </div>
        <div className="team-cofound">
          <p>
            Ben and Reilly are deeply passionate about the world of clinical exercise physiology and co-founded <a href="https://thehealthnav.co.uk" target="_blank" rel="noopener noreferrer">thehealthnav.co.uk</a>,
            a platform helping people navigate the world of exercise physiology, find trusted practitioners, and access health and wellness resources.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Team;